// CS Server
const Actions = {
  // development: 'http://125.227.53.126:3009',
  development: 'http://192.168.1.194:3009',
  // 測試機
  // production_test: 'http://125.227.53.126:3009',
  production_test: 'http://192.168.1.194:3009',
  // 正式機
  production: 'https://www.owfsupv.tw/itri-wfc-be',
};

const Ip = {
  Actions: Actions[process.env.mode], // CS Server
};

const Link_GIS = {
  development: 'http://125.227.53.126:3006/map/go?token=',
  // 測試機
  production_test: 'http://125.227.53.126:3006/map/go?token=',
  // 正式機
  production: 'https://www.owfsupv.tw/map/go?token=',
};

const LINK_GIS = Link_GIS[process.env.mode];

const rootPath = '';

const frontTitle = '離岸風力發電設置案件工作進度資訊管考平台';
const backTitle = '離岸風力發電設置案件工作進度資訊管考平台';

export default { Ip, LINK_GIS, rootPath, frontTitle, backTitle };
